export const DEFAULT_TOTALS = {
  payroll_users: 0,
  payroll_balance: 0,
  overdraft: 0,
  available_credit: 0,
  consumed_credit: 0,
  active_invoices: 0,
  overdue_invoices: 0,
  outstanding_amount: 0,
};

export default {
  dashboardData: JSON.parse(localStorage.getItem("dashboardData")) || {
    totals: {
      trips: 0,
      shipments: 0,
    },
    details: {
      trips: [],
      shipments: [],
    },
  },
  loadingDashboard: false,
  loadingUsers: false,
  loadingAssociatedPanels: false,
  loadingCreditDistribution: false,
  totalCollaborators: 0,
  lastUpdate: localStorage.getItem('dashboardLastUpdate') || null,
  associatedPanels: localStorage.getItem('associatedPanels')
    ? JSON.parse(localStorage.getItem('associatedPanels'))
    : [],
  creditDistribution: localStorage.getItem('creditDistribution')
    ? JSON.parse(localStorage.getItem('creditDistribution'))
    : {
        master_credit_limit: 0,
        panels: [],
      },
  creditDistributionLastUpdate:
    localStorage.getItem('creditDistributionLastUpdate') || null,
};
